{
  "schemaVersion": 1,
  "id": "cinderwake-environment-kit-v2",
  "status": "controlled-runtime-integration-approved",
  "source": {
    "file": "art/source/environment/environment-kit-v2-source.png",
    "sha256": "2af4efd5dad1a3b0472c7360b53851f6d329ac6254aa59024f3191a06da00210",
    "pixelWidth": 1536,
    "pixelHeight": 1024,
    "columns": 3,
    "rows": 2,
    "cellWidth": 512,
    "cellHeight": 512
  },
  "atlas": {
    "file": "environment-kit-v2.png",
    "pixelWidth": 1536,
    "pixelHeight": 1024
  },
  "provenance": {
    "preparedFile": "art/generation/environment-kit/prepared/environment-kit-v2.png",
    "generationRecord": "art/generation/environment-kit-v2.json",
    "reviewEvidence": "art/generation/environment-kit/evidence/environment-kit-v2/report.json",
    "auditCommit": "7b4b55725c2726042aa57fd9d570d5a60655e850",
    "scope": "The exact independently approved prepared bytes are promoted only for the controlled runtime integration trial."
  },
  "cells": [
    {
      "index": 0,
      "id": "scenery:architecture:north-wall-solid",
      "cell": { "x": 0, "y": 0, "width": 512, "height": 512 },
      "ink": { "x": 65, "y": 96, "width": 382, "height": 351 },
      "logicalSize": { "width": 187, "height": 172 },
      "anchor": { "mode": "bottom-center", "x": 93.5, "y": 172 }
    },
    {
      "index": 1,
      "id": "scenery:structure:forge-workshop",
      "cell": { "x": 512, "y": 0, "width": 512, "height": 512 },
      "ink": { "x": 65, "y": 107, "width": 383, "height": 340 },
      "logicalSize": { "width": 220, "height": 195 },
      "anchor": { "mode": "bottom-center", "x": 110, "y": 195 }
    },
    {
      "index": 2,
      "id": "scenery:prop:lantern-a",
      "cell": { "x": 1024, "y": 0, "width": 512, "height": 512 },
      "ink": { "x": 169, "y": 65, "width": 171, "height": 383 },
      "logicalSize": { "width": 53, "height": 118 },
      "anchor": { "mode": "bottom-center", "x": 26.5, "y": 118 }
    },
    {
      "index": 3,
      "id": "scenery:prop:lantern-b",
      "cell": { "x": 0, "y": 512, "width": 512, "height": 512 },
      "ink": { "x": 170, "y": 65, "width": 173, "height": 382 },
      "logicalSize": { "width": 53, "height": 118 },
      "anchor": { "mode": "bottom-center", "x": 26.5, "y": 118 }
    },
    {
      "index": 4,
      "id": "scenery:prop:barricade-v2",
      "cell": { "x": 512, "y": 512, "width": 512, "height": 512 },
      "ink": { "x": 65, "y": 131, "width": 385, "height": 318 },
      "logicalSize": { "width": 107, "height": 88 },
      "anchor": { "mode": "bottom-center", "x": 53.5, "y": 88 }
    },
    {
      "index": 5,
      "id": "scenery:prop:raised-clutter-bench",
      "cell": { "x": 1024, "y": 512, "width": 512, "height": 512 },
      "ink": { "x": 63, "y": 128, "width": 384, "height": 318 },
      "logicalSize": { "width": 124, "height": 103 },
      "anchor": { "mode": "bottom-center", "x": 62, "y": 103 }
    }
  ]
}
